module.exports = __webpack_public_path__ + "static/writers-uhc-a4814520cfe66e6e442341c17d654108.jpg";